import HttpService from "./httpService";

export const getUserInfo = () => {
  let uri = `/user/userinfo`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};
